import { LandingPage } from '../LandingPage';
import { golfTeachersConfig } from './config';

export default function GolfTeachersLandingPage() {
  return <LandingPage config={golfTeachersConfig} />;
}
